// extracted by mini-css-extract-plugin
export default {"mostViewdReportsContainer":"index_mostViewdReportsContainer__J4Vmb"};